import {
  StaffReviewConflictError,
  parseStaffReviewConflictFromError,
} from "./staff-review-conflict";

export async function runStaffReviewAction(
  action: () => Promise<void>,
): Promise<void> {
  try {
    await action();
  } catch (error) {
    const conflict = await parseStaffReviewConflictFromError(error);
    if (conflict) {
      throw new StaffReviewConflictError(conflict);
    }
    throw error;
  }
}
